import * as React from "react"
import {
  IconHome,
  IconSchool,
  IconBriefcase,
  IconWallet,
  TablerIcon,
} from "@tabler/icons"
import { graphql, StaticQuery } from "gatsby"

const icons: { [key: string]: TablerIcon } = {
  home: IconHome,
  school: IconSchool,
  briefcase: IconBriefcase,
  wallet: IconWallet,
}

const query = graphql`
  query MyQuery {
    allHighlights {
      nodes {
        icon
        label {
          de
          en
          nl
        }
      }
    }
  }
`

export interface HighlightsProps {
  lang: string
}

export class Highlights extends React.Component<HighlightsProps> {
  render() {
    return (
      <StaticQuery
        query={query}
        render={data => {
          return (
            <div className="grid gap-8 grid-cols-2 lg:grid-cols-4">
              {data.allHighlights.nodes.map(
                (node: { icon: string; label: { [key: string]: string } }) => {
                  const Icon = icons[node.icon]
                  return (
                    <div className="flex flex-col items-center" key={node.icon}>
                      <Icon size={80} stroke={1.2} />
                      <span className="sm:text-lg text-sm font-bold">
                        {node.label[this.props.lang]}
                      </span>
                    </div>
                  )
                }
              )}
            </div>
          )
        }}
      />
    )
  }
}
